<kiwi-select-period [currentPeriod]="currentPeriod" [periods]="periods"></kiwi-select-period>
